
import React from 'react';
import { Star, Award, Shield } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const QualityAssurance = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Gradient background */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: "linear-gradient(109.6deg, rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1%)",
          opacity: "0.5"
        }}
      />

      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div className="w-full h-full" 
          style={{
            backgroundImage: "radial-gradient(circle, #004080 1px, transparent 1px)",
            backgroundSize: "24px 24px"
          }}>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-serif">
            Our Promise to You
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-xl text-navy/80 font-serif italic mb-8">
            "Excellence Refined. Trust Preserved."
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Card className="border-2 border-gold/20 shadow-lg backdrop-blur-sm bg-white/80">
            <CardContent className="p-8">
              <div className="flex flex-col gap-8">
                <div className="flex items-start gap-4">
                  <Star className="h-6 w-6 text-gold shrink-0 mt-1" />
                  <p className="text-gray-600">
                    Gold Standard Cleaning Group pledges uncompromising attention to detail, delivering a standard of cleanliness that quietly exceeds expectations — every time we enter your home.
                  </p>
                </div>
                
                <div className="flex items-start gap-4">
                  <Shield className="h-6 w-6 text-gold shrink-0 mt-1" />
                  <p className="text-gray-600">
                    Your trust is our highest priority. We honor your privacy with absolute discretion, maintain strict confidentiality, and care for your residence as a private sanctuary.
                  </p>
                </div>
                
                <div className="flex items-start gap-4">
                  <Award className="h-6 w-6 text-gold shrink-0 mt-1" />
                  <p className="text-gray-600">
                    Backed by Gold Standard Cleaning Group's unwavering satisfaction guarantee, we ensure each service leaves your home — and your peace of mind — impeccably maintained.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default QualityAssurance;
